import {
	BackImage,
	Saudiflag,
	Usaflag,
	AustraliaFlag,
	Chainaflag,
	Europflag,
	Qatarflag,
	Indiaflag,
	logo1,
	logo2,
	logo3,
	logo4,
	logo5,
	logo6,
	logo7,
	logo8,
	logo9,
	mobileback,
	heroImage,
	homemain,
	about_logo,
	home_main_mobile,
	image_slide_1,
	image_slide_4,
	image_slide_2,
	image_slide_3,
	image_mslide_1,
	image_mslide_2,
	image_mslide_3,
	image_mslide_4,
	OmanFlag
} from '../assets/images';
import Navbar from '../components/Navbar';
import RightArrowIcon from '../assets/icons/rightArrow';
import CrownIcon from '../assets/icons/crownIcon';
import { useEffect, useState, useRef } from 'react';
import Footer from '../components/Footer';
import DashedBorder from '../assets/icons/border';
import ArrowRightIcon from '../assets/icons/arrow-right';
import ArrowLeftIcon from '../assets/icons/arrow-left';
import { useNavigate } from 'react-router-dom';
import products from '../Data/products.json';
import images from '../assets/images';
import Downloadbroch from '../components/Downloadbroch';

const Home = () => {
	const cards = [
		{
			icon: '🌍',
			value: '25+',
			label: 'Countries Served',
		},
		{
			icon: '🤝',
			value: '500+',
			label: 'Global Clients',
		},
		{
			icon: '🏭',
			value: '4k+',
			label: 'Tons Capacity Annually',
		},
		{
			icon: '📦',
			value: '20+',
			label: 'Product Variants',
		},
		{
			icon: '⭐',
			value: '99%',
			label: 'On-Time Delivery Rate',
		},
	];
	const cardsMobile = [
		{
			icon: '🌍',
			value: '25+',
			label: 'Countries Served',
		},
		{
			icon: '🤝',
			value: '500+',
			label: 'Global Clients',
		},
		{
			icon: '🏭',
			value: '4k+',
			label: 'Tons Capacity Annually',
		},
		{
			icon: '⭐',
			value: '99%',
			label: 'On-Time Delivery Rate',
		},
	];
	const countries = [
		{ name: 'INDIA', img: Indiaflag },
		{ name: 'OMAN', img: OmanFlag },
		{ name: 'QATAR', img: Qatarflag },
		{ name: 'SAUDI ARABIA', img: Saudiflag },
		// { name: 'CHINA', img: Chainaflag },
		{ name: 'USA', img: Usaflag },
		{ name: 'AUSTRALIA', img: AustraliaFlag },
		{ name: 'EUROPE', img: Europflag },
		{ name: '+25', img: null, subText: 'Countries' },
	];
	const logos = [
		{
			name: 'Balaji Wafers',
			img: logo1,
			imgWidth: '100px',
			imgHeight: '100px',
			smImgWidth: '80px',
			smImgHeight: '80px',
			url: 'https://www.balajiwafers.com/',
		},
		{
			name: 'IGL',
			img: logo2,
			imgWidth: '164px',
			imgHeight: '49px',
			smImgWidth: '130px',
			smImgHeight: '49px',
			url: 'https://gcc.luluhypermarket.com/en-ae',
		},
		{
			name: 'Gopal Namkeen',
			img: logo3,
			imgWidth: '100px',
			imgHeight: '91.6px',
			smImgWidth: '70px',
			smImgHeight: '70px',
			url: 'https://choithramsgcc.com/en',
		},
		{
			name: 'M',
			img: logo4,
			imgWidth: '181px',
			imgHeight: '52px',
			smImgWidth: '100px',
			smImgHeight: '50px',
			url: 'https://www.costco.com/',
		},
		{
			name: 'Mentone',
			img: logo5,
			imgWidth: '134px',
			imgHeight: '134px',
			smImgWidth: '100px',
			smImgHeight: '100px',
			url: 'https://www.maggi.in/en/#',
		},
		{
			name: 'Kalamandir',
			img: logo6,
			imgWidth: '150px',
			imgHeight: '150px',
			smImgWidth: '110px',
			smImgHeight: '110px',
			url: 'https://www.kalamandirjewellersgroup.com/',
		},
		{
			name: 'Portico',
			img: logo7,
			imgWidth: '100px',
			imgHeight: '100px',
			smImgWidth: '80px',
			smImgHeight: '80px',
			url: 'https://stores.porticonewyork.in/portico/jamnagar/Reliance-Green-Mall/portico-exclusive-store-premium-home-linen-brand-in-Reliance-Green-Mall-jamnagar--6YBdbX/home',
		},
		{
			name: 'MS',
			img: logo8,
			imgWidth: '100px',
			imgHeight: '100px',
			smImgWidth: '80px',
			smImgHeight: '80px',
			url: 'https://www.maharajasweets.in/',
		},
		{
			name: 'MS',
			id: '44',
			img: logo8,
			imgWidth: '100px',
			imgHeight: '100px',
			smImgWidth: '80px',
			smImgHeight: '80px',
		},
		{
			name: 'IGL',
			img: logo9,
			imgWidth: '80px',
			imgHeight: '80px',
			smImgWidth: '68px',
			smImgHeight: '68px',
			url: 'https://iglfertilizers.com/',
		},
		{ name: '+150 Brands Worldwide', img: null },
	];

	const stats = [
		{ value: '15+', label: 'MNCs served' },
		{ value: '3', label: 'units across Gujarat' },
		{ value: '1200+', label: 'Hard-working Staff', shortLabel: 'Staff' },
		{ value: '24/7', label: 'Working Capacity' },
	];

	const [isSmallScreen, setIsSmallScreen] = useState(false);
	const [isTablet, setIsTablet] = useState(false);
	const [index, setIndex] = useState(0);
	const [slideIndex, setSlideIndex] = useState(0);
	const desktopImages = [
		image_slide_1,
		image_slide_2,
		image_slide_3,
		image_slide_4,
	];

	const mobileImages = [
		image_mslide_1,
		image_mslide_2,
		image_mslide_3,
		image_mslide_4,
	];
	const backimages = isSmallScreen ? mobileImages : desktopImages;
	const [cols, setCols] = useState(4);
	const iconSize = isSmallScreen ? 20 : 24;
	const displayCards = isSmallScreen ? cardsMobile : cards;
	const navigate = useNavigate();
	const [selectedCategory, setSelectedCategory] =
		useState('Retail & Shopping');
	const filteredProducts = products.filter(
		(item) => item.category === selectedCategory,
	);
	const scrollContainerRef = useRef(null);
	// .slice(0, 3);
	useEffect(() => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollTo({
				left: 0,
				behavior: 'smooth',
			});
		}
	}, [selectedCategory]);

	const scrollWrapperRef = useRef(null);

	useEffect(() => {
		if (window.innerWidth <= 1440) return;
		const wrapper = scrollWrapperRef.current;
		if (!wrapper) return;
		const container = wrapper.querySelector('.overflow-x-auto');
		if (!container) return;

		let isDragging = false;
		let startX = 0;
		let startScrollLeft = 0;
		const imgs = container.querySelectorAll('img');
		imgs.forEach((img) => {
			img.addEventListener('dragstart', (e) => e.preventDefault());
			img.style.pointerEvents = 'auto';
			img.style.userSelect = 'none';
		});

		const preventUserSelect = () => {
			document.body.style.userSelect = 'none';
			//  document.body.style.cursor = 'grabbing';
		};
		const restoreUserSelect = () => {
			document.body.style.userSelect = '';
			// document.body.style.cursor = '';
		};

		const handleMouseDown = (e) => {
			if (e.button !== 0) return;
			isDragging = true;
			startX = e.pageX - container.offsetLeft;
			startScrollLeft = container.scrollLeft;
			preventUserSelect();
		};

		const handleMouseMove = (e) => {
			if (!isDragging) return;
			e.preventDefault();
			const x = e.pageX - container.offsetLeft;
			const walk = (x - startX) * 1.2;
			container.scrollLeft = startScrollLeft - walk;
		};

		const stopDrag = () => {
			isDragging = false;
			restoreUserSelect();
		};

		// Attach listeners to the CONTAINER, not wrapper
		container.addEventListener('mousedown', handleMouseDown);
		window.addEventListener('mousemove', handleMouseMove, {
			passive: false,
		});
		window.addEventListener('mouseup', stopDrag);

		return () => {
			container.removeEventListener('mousedown', handleMouseDown);
			window.removeEventListener('mousemove', handleMouseMove);
			window.removeEventListener('mouseup', stopDrag);
			restoreUserSelect();
		};
	}, [selectedCategory]);

	useEffect(() => {
		const updateColumns = () => {
			if (window.innerWidth >= 1280) setCols(4); // xl
			else if (window.innerWidth >= 1024) setCols(3); // lg
			else if (window.innerWidth >= 768) setCols(2); // md
			else setCols(2);
		};

		updateColumns();
		window.addEventListener('resize', updateColumns);

		return () => window.removeEventListener('resize', updateColumns);
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setIsSmallScreen(window.innerWidth < 640);
			setIsTablet(window.innerWidth <= 1024);
		};

		handleResize();
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);
	const items = [
		{
			image: homemain,
			mobileImage: home_main_mobile,
			title: 'Non Woven Bags & Packaging Materials for Every Industry',
			desc: 'From fruit & vegetable covers to hygienic disposable caps and shoe covers — we deliver eco-friendly, export-grade solutions trusted worldwide.',
		},
		{
			image: homemain,
			mobileImage: home_main_mobile,
			title: 'Non Woven Bags & Packaging Materials for Every Industry',
			desc: 'From fruit & vegetable covers to hygienic disposable caps and shoe covers — we deliver eco-friendly, export-grade solutions trusted worldwide.',
		},
		{
			image: homemain,
			mobileImage: home_main_mobile,
			title: 'Non Woven Bags & Packaging Materials for Every Industry',
			desc: 'From fruit & vegetable covers to hygienic disposable caps and shoe covers — we deliver eco-friendly, export-grade solutions trusted worldwide.',
		},
	];

	const handleNext = () => {
		setSlideIndex((prev) => (prev + 1) % backimages.length);
	};

	const handlePrev = () => {
		setSlideIndex((prev) => (prev - 1 + backimages.length) % backimages.length);
	};
	const item = items[index];
	const bgImage = isSmallScreen ? item.mobileImage : item.image;
	
	return (
		<div className="w-full">
			{/* <div className="relative overflow-hidden">
				<div
					className="flex xs:h-[720px] ms:h-[695px] sm:h-[689px] md:h-[689px] lg:h-[788px] w-full  transition-all duration-700 ease-in-out justify-center  
					bg-center sm:bg-center md:bg-center lg:bg-center xl:bg-[position:center_left] 2xl:bg-[position:center_left]"
					style={{
						backgroundImage:
							isSmallScreen ?
								`linear-gradient(225.42deg, #000000 19.01%, rgba(0, 0, 0, 0) 28.12%, rgba(0, 0, 0, 0) 36.49%, rgba(0, 0, 0, 0.80) 47.51%, #000000 81.02%),linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%),url(${bgImage})`
								:
								`linear-gradient(256.37deg, #000000 0%, rgba(0,0,0,0) 14.68%, rgba(0,0,0,0) 28.19%, rgba(0,0,0,0.76) 66.31%, #000000 100%),linear-gradient(180deg, #000000 0%, rgba(0,0,0,0) 14.91%, rgba(0,0,0,0) 100%),url(${bgImage})`
						,
						backgroundRepeat: 'no-repeat',
						// backgroundPosition: 'center center',
						backgroundSize: 'cover',
					}}
				>
					<Navbar />
					<div className="absolute max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[427px] ms:w-full xs:w-full xl:h-[450px] lg:h-[450px] md:h-[320px] h-[330px] xl:pl-[100px] lg:pl-0 md:pl-0 sm:pl-[20px] pl-[20px] xl:top-[194px] lg:top-[194px] md:top-[260px] sm:top-[280px] top-[280px]">
						<div className="flex flex-col absolute">
							<h1 className="text-white leading-[140%] text-left text-[32px] sm:text-[32px] md:text-[40px] lg:text-[60px] xl:w-[538px] lg:w-[538px] md:w-[538px] sm:w-[264px] w-[261px] xl:h-[252px] lg:h-[252px] ms:h-fit xs:h-fit tracking-[0] text-goudy xl:font-medium lg:font-medium md:font-medium sm:font-bold ms:font-bold xs:font-bold">
								{item.title}
							</h1>
							<p className="text-white font-google font-normal leading-[180%] text-left text-[14px] sm:text-[14px] md:text-[18px] w-[261px] sm:w-[261px] md:w-[420px] xl:h-[96px] lg:h-[96px] md:h-[96px] sm:h-[96px] ms:h-fit xs:h-fit mt-[16px]">
								{item.desc}
							</p>
							<div className="flex xl:flex-row lg:flex-row md:flex-row sm:flex-row ms:flex-row xs:flex-col xl:w-[390px] lg:w-[390px] md:w-[390px] sm:w-[353px] ms:w-full xs:w-full xl:h-[47px] lg:h-[47px] md:h-[47px] sm:h-[40px] h-[40px] xl:mt-[28px] lg:mt-[28px] md:mt-[28px] sm:mt-[24px] mt-[24px] xl:gap-[16px] lg:gap-[16px] md:gap-[16px] sm:gap-[10px] gap-[10px]">
								<button
									className="flex items-center justify-center rounded-[30px] bg-white shadow-[0_4px_12px_0_#0000001F] px-[24px] py-[10px] cursor-pointer w-[200px] h-[40px] sm:w-[200px] sm:h-[40px] md:w-[208px] md:h-[47px] lg:w-[208px] lg:h-[47px] xl:w-[208px] xl:h-[47px] text-black text-[14px] sm:text-[14px] md:text-[16px] lg:text-[16px] xl:text-[16px] font-[500] text-center font-google"
									onClick={() => navigate('/products')}
								>
									Explore Our Products
								</button>
								<span
									className="flex items-center justify-center rounded-[30px] w-[166px] xl:h-[47px] lg:h-[47px] md:h-[47px] h-[40px] sm:h-[40px] px-[24px] py-[10px] text-white text-[14px] sm:text-[14px] md:text-[16px] lg:text-[16px] xl:text-[16px] font-[500] text-center underline font-google cursor-pointer"
									onClick={() => navigate('/contact')}
								>
									Get In Touch
								</span>
							</div>
						</div>
					</div>
				</div>
				
			</div> */}
			<div className="relative overflow-hidden">
				<div
					className="flex xs:h-[720px] ms:h-[695px] sm:h-[689px] md:h-[689px] lg:h-[788px] w-full  transition-all duration-700 ease-in-out justify-center  
					bg-center sm:bg-center md:bg-center lg:bg-center xl:bg-[position:center_left] 2xl:bg-[position:center_left]"
					style={{
						backgroundImage: isSmallScreen
							? `url(${home_main_mobile})`
							: `url(${homemain})`,
						backgroundRepeat: 'no-repeat',
						backgroundSize: 'cover',
					}}
				>
					<div
						className="absolute inset-0 pointer-events-none "
						style={{
							 opacity: isSmallScreen ? "0.8" : "1",
							background: isSmallScreen
								? `
							linear-gradient(225.42deg, rgb(0, 0, 0) 1.01%, rgba(0, 0, 0, 0) 5.12%, rgba(0, 0, 0, 0) 21.49%, rgba(0, 0, 0, 0.76) 51.51%, rgb(0, 0, 0) 76.02%), linear-gradient(rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 19.91%, rgba(0, 0, 0, 0) 100%)
							`
				
													: `
							linear-gradient(256.37deg, #000000 0%, rgba(0, 0, 0, 0) 14.68%, rgba(0, 0, 0, 0) 28.19%, rgba(0, 0, 0, 0.76) 66.31%, #000000 100%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%)
							`
						}}
					></div>

					<Navbar />

					<span  className="absolute max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[427px] ms:w-full xs:w-full xl:h-[450px] lg:h-[450px] md:h-[320px] h-[330px] xl:pl-[100px] lg:pl-0 md:pl-0 sm:pl-[20px] pl-[20px] xl:top-[194px] lg:top-[194px] md:top-[260px] sm:top-[280px] top-[280px]">
						<div className="flex flex-col absolute">
							<h1 className="text-white leading-[140%] text-left text-[32px] sm:text-[32px] md:text-[40px] lg:text-[60px] xl:w-[538px] lg:w-[538px] md:w-[538px] sm:w-[264px] w-[261px] xl:h-[252px] lg:h-[252px] ms:h-fit xs:h-fit tracking-[0] text-goudy xl:font-medium lg:font-medium md:font-medium sm:font-bold ms:font-bold xs:font-bold">
								{item.title}
							</h1>
							<p className="text-white font-google font-normal leading-[180%] text-left text-[14px] sm:text-[14px] md:text-[18px] w-[261px] sm:w-[261px] md:w-[420px] xl:h-[96px] lg:h-[96px] md:h-[96px] sm:h-[96px] ms:h-fit xs:h-fit mt-[16px]">
								{item.desc}
							</p>
							<div className="flex xl:flex-row lg:flex-row md:flex-row sm:flex-row ms:flex-row xs:flex-col xl:w-[390px] lg:w-[390px] md:w-[390px] sm:w-[353px] ms:w-full xs:w-full xl:h-[47px] lg:h-[47px] md:h-[47px] sm:h-[40px] h-[40px] xl:mt-[28px] lg:mt-[28px] md:mt-[28px] sm:mt-[24px] mt-[24px] xl:gap-[16px] lg:gap-[16px] md:gap-[16px] sm:gap-[10px] gap-[10px]">
								<button
									className="flex items-center justify-center rounded-[30px] bg-white shadow-[0_4px_12px_0_#0000001F] px-[24px] py-[10px] cursor-pointer w-[200px] h-[40px] sm:w-[200px] sm:h-[40px] md:w-[208px] md:h-[47px] lg:w-[208px] lg:h-[47px] xl:w-[208px] xl:h-[47px] text-black text-[14px] sm:text-[14px] md:text-[16px] lg:text-[16px] xl:text-[16px] font-[500] text-center font-google"
									onClick={() => navigate('/products')}
								>
									Explore Our Products
								</button>
								<span
									className="flex items-center justify-center rounded-[30px] w-[166px] xl:h-[47px] lg:h-[47px] md:h-[47px] h-[40px] sm:h-[40px] px-[24px] py-[10px] text-white text-[14px] sm:text-[14px] md:text-[16px] lg:text-[16px] xl:text-[16px] font-[500] text-center underline font-google cursor-pointer"
									onClick={() => navigate('/contact')}
								>
									Get In Touch
								</span>
							</div>
						</div>
					</span>
				</div>
			</div>
			<div
				className="relative flex flex-col xl:justify-center lg:justify-center md:justify-center sm:justify-start justify-start items-center xl:h-[1480px] lg:h-[1480px] md:h-[1800px] sm:h-[1340px] ms:h-[1350px] xs:h-[1600px] bg-no-repeat bg-cover bg-center w-full"
				style={{
					// backgroundImage: `url(${BackImage})`,
					backgroundImage: `url(${isSmallScreen ? mobileback : BackImage
						})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: isSmallScreen ? 'cover' : 'auto',
					backgroundPosition: 'center bottom',
				}}
			>
				<div className="flex flex-col xl:w-[1200px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full xl:h-[550px] lg:h-[550px] md:h-fit opacity-100 xl:gap-10 lg:gap-10 md:gap-10 sm:gap-[24px] gap-[24px] items-center">
					<div className="flex flex-col lg:flex-row  w-full xl:gap-[24px] lg:gap-[24px] md:gap-[24px] sm:gap-[12px] gap-[12px] pl-5 md:pl-0 md:justify-between justify-start xl:items-center lg:items-center md:items-start items-start">
						<span className="xl:w-[708px] w-fit xl:h-[146px] h-fit text-black text-[28px] sm:text-[28px] md:text-[42px] lg:text-[42px] xl:text-[52px] text-goudy xl:font-normal lg:font-normal md:font-normal sm:font-bold font-bold leading-[140%] pt-[60px] sm:pt-[60px] md:pt-0 lg:pt-0 xl:pt-0">
							Delivering Quality,
							<br className="block md:hidden" /> Sustainability
							<br className="md:block hidden" /> &{' '}
							<br className="block md:hidden" /> Reliability —
							Since 2015
						</span>
						<button
							className="flex items-center justify-center xl:w-[238px] w-fit h-[47px] gap-[10px] rounded-[30px] 
                              px-[24px] py-[10px] shadow-[0_4px_20px_0_#0000001F] bg-black cursor-pointer text-white text-[14px] sm:text-[16px] font-google font-[500] leading-[100%] tracking-[0%]"
							onClick={() => navigate('/about')}
						>
							Learn more About us
							<RightArrowIcon />
						</button>
					</div>
					<div className="flex flex-col lg:flex-row xl:w-[1200px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full justify-between md:gap-6 gap-[20px] items-center">
						<div className="relative">
							<span
								className="bg-grey-300 xl:w-[790px] lg:w-[500px] md:w-[700px] sm:w-[353px] ms:w-[353px] xs:w-[300px] xl:h-[364px] lg:h-[364px] md:h-[364px] h-[163px] rounded-[24px] shadow-[0_4px_20px_0_#0000000F] block  transition-all duration-700 ease-in-out"
								style={{
									backgroundImage: `url(${backimages[slideIndex]})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									willChange: "background-image",
								}}
							></span>
							<div className="absolute bottom-[12px] w-full flex justify-center items-center gap-4 z-10">
								<button
									onClick={handlePrev}
									className="text-white text-[18px] opacity-100"
								>
									<ArrowLeftIcon
										ishome={true}
										width={24}
										height={24}
									/>
								</button>
								<div className="flex items-center gap-[4px]">
									{backimages.map((_, i) => (
										<div
											key={i}
											className={`rounded-[4.5px] transition-all duration-300 ${i === slideIndex
													? 'w-[30px] h-[9px] bg-white'
													: 'w-[9px] h-[9px] bg-white/40'
												}`}
										></div>
									))}
								</div>
								<button
									onClick={handleNext}
									className="text-white text-[18px] opacity-100"
								>
									<ArrowRightIcon
										ishome={true}
										width={24}
										height={24}
									/>
								</button>
							</div>
						</div>
						<div className="xl:w-[386px] lg:w-[386px] md:w-full xl:h-[364px] lg:h-[364px] md:h-[364px] sm:h-[279px] h-[279px] rounded-[24px] bg-white  shadow-[0_4px_20px_0_#0000000F] flex items-center relative">
							<DashedBorder
								radiusDesktop={24}
								radiusMobile={24}
							/>
							<div className="xl:w-[386px] lg:w-[386px] md:w-[386px] sm:w-[353px] ms:w-[353px] xs:w-[300px] xl:h-[364px] lg:h-[364px] md:h-[364px] sm:h-[279px] ms:h-[279px] xs:h-[290px] rounded-[16px] opacity-100 flex flex-col justify-start xl:gap-[32px] lg:gap-[32px] md:gap-[32px] sm:gap-[16px] gap-[16px] xl:pt-8 lg:pt-8 md:pt-8 sm:pt-[22px] pt-[22px] xl:px-8 lg:px-4 md:px-8 sm:px-[22px] px-[22px]">
								<h1 className="text-black text-left text-[26px] sm:text-[26px] md:text-[32px] text-goudy font-bold leading-[120%]">
									Our Expertise
								</h1>
								<div className="w-full flex flex-col gap-[20px]">
									{[
										'12–120 gsm Non-woven Bag Experts',
										'Eco-Friendly & Recyclable Packaging',
										'Multi-Industry Applications',
										'Customizable & Durable Designs',
										'Export-Grade Quality Assurance',
									].map((text, index) => (
										<div
											key={index}
											className="flex items-center gap-[10px]"
										>
											<CrownIcon
												width={iconSize}
												height={iconSize}
											/>
											<span className="text-black text-[14px] xl:text-[16px] font-plusJakarta font-normal leading-[100%]">
												{text}
											</span>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="relative xl:w-[1200px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-auto xl:h-[162px] lg:h-fit md:h-fit flex flex-wrap grid xs:grid-cols-1 ms:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 xl:justify-between lg:justify-between md:justify-start sm:justify-between justify-between mt-5 gap-y-5 xl:px-0 lg:px-0 md:px-0 sm:px-5 ms:px-3 xl:gap-x-0 lg:gap-x-0 md:gap-x-[50px] sm:gap-x-0 gap-x-0">
					{displayCards.map((card, index) => (
						<div
							key={index}
							className="custom-dashed-border xl:w-[224px] lg:w-[200px] md:w-[200px] sm:w-[169px] ms:w-[169px] xs:w-full xl:h-[162px] lg:h-[162px] md:h-[162px] sm:h-[122px] h-[122px] bg-white  rounded-[24px]
							shadow-[0px_4px_20px_0px_#0000000F] flex flex-col justify-center items-center
							py-[30px] px-[25px] opacity-100 relative"
						>
							<DashedBorder
								radiusDesktop={24}
								radiusMobile={24}
							/>
							<span className="flex gap-[6px] justify-center items-center">
								<span className="xl:text-[52px] lg:text-[52px] md:text-[36px] text-[36px]  text-goudy">
									{card.icon}
								</span>
								<h1 className="text-black xl:text-[50px] lg:text-[50px] md:text-[36px] text-[36px] leading-[120%] text-center text-goudy font-normal tracking-0">
									{card.value}
								</h1>
							</span>
							<p className="text-black text-[14px] xl:text-[16px] lg:text-[16px] leading-[140%] text-center font-google font-normal tracking-0">
								{card.label}
							</p>
						</div>
					))}
				</div>
				<div className="w-full flex flex-col justify-center items-center xl:pt-[120px] lg:pt-[50px] md:pt-[70px] sm:pt-[55px] pt-[55px]">
					<span className="xl:w-[898px] lg:w-[800px] md:w-[700px] flex flex-col xl:gap-[9px] lg:gap-[9px] md:gap-[9px] sm:gap-[18px] gap-[18px] opacity-100">
						<span className="w-full xl:h-[206px] lg:h-[206px] md:h-fit flex items-center justify-center opacity-100">
							<img
								src={about_logo}
								alt="ZECCA Logo"
								className="object-contain xl:h-[206px] xl:w-[898px] lg:h-[206px] lg:w-[898px] md:h-[120px] md:w-[898px] sm:h-[58px] h-[58px] sm:w-[289px] w-[289px]"
							/>
						</span>
						<span className="w-full flex flex-col xl:flex-row lg:flex-row md:flex-row sm:flex-col justify-between items-center opacity-100">
							<p className="xl:w-[325px] lg:w-[325px] md:w-[325px] sm:w-full ms:w-full xs:w-full flex items-center justify-center text-black text-[14px] xl:text-[16px] lg:text-[16px] md:text-[14px] leading-[150%] text-center xl:text-left lg:text-left md:text-left font-normal font-google">
								Believe. Behave. Become.
							</p>
							<button
								className="w-[209px] h-[47px] mt-4 xl:mt-0 lg:mt-0 md:mt-0 sm:md-0 flex items-center justify-center gap-[10px] rounded-[30px] opacity-100 bg-black cursor-pointer text-white text-[14px] xl:text-[16px] lg:text-[16px] md:text-[14px] font-google font-medium leading-[100%] tracking-[0%]"
								style={{
									padding: '10px 24px',
									boxShadow: '0px 4px 20px 0px #0000001F',
								}}
								onClick={() => navigate('/products')}
							>
								Explore Products
								<RightArrowIcon />
							</button>
						</span>
					</span>
				</div>
			</div>
			<div className="w-full bg-white flex flex-col justify-start items-center xl:py-[120px] lg:py-[120px] md:py-[120px] sm:py-[60px] py-[60px] xl:h-[1566px] lg:h-[1880px] md:h-[2275px] sm:h-[1770px] h-[1770px]">
				<h1 className="text-black text-goudy xl:font-normal lg:font-normal md:font-normal sm:font-bold font-bold xl:text-[52px] lg:text-[52px] md:text-[40px] sm:text-[28px] text-[28px] xl:leading-[120%] lg:leading-[120%] md:leading-[120%] sm:leading-[140%] leading-[140%] text-center">
					Countries & Brands <br className="block md:hidden" /> We
					have Served
				</h1>
				<div
					className={`xl:w-[1200px] lg:w-[900px] md:w-[600px] sm:w-[354px] ms:w-[354px] xs:w-[300px]
					xl:h-[510px] lg:h-[780px] md:h-[1024px] sm:h-[640px] h-[640px]
					bg-white rounded-[24px] 
					shadow-[0px_4px_20px_0px_#0000000F] lg:mt-[40px] xl:mt-[40px] md:mt-[30px] sm:mt-[20px] mt-[20px]
					grid grid-cols-2 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 relative`}
				>
					<DashedBorder
						radiusDesktop={24}
						radiusMobile={24}
					/>
					{countries.map((country, index) => {
						const isLastCol = (index + 1) % cols === 0;
						const totalRows = Math.ceil(countries.length / cols);
						const currentRow = Math.floor(index / cols) + 1;
						const isLastRow = currentRow === totalRows;

						// const borderClasses = `
						// 	${!isLastCol ? 'border-r border-dashed border-[#C4BAA3]' : ''}
						// 	${!isLastRow ? 'border-b border-dashed border-[#C4BAA3]' : ''}
						// `;

						return (
							<div
								key={index}
								className={`flex flex-col items-center justify-center relative
								xl:w-[300px] lg:w-[300px] md:w-[300px] sm:w-[177px] ms:w-[177px] xs:w-[150px]
								xl:h-[255px] lg:h-[255px] md:h-[255px] sm:h-[160px] h-[160px]`}
							>
								{!isLastCol && (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="1"
										height="100%"
										className="absolute"
										style={{
											top: '0',
											right: '0',
											bottom: 'auto',
											left: 'auto',
										}}
									>
										<line
											x1="0"
											y1="0"
											x2="0"
											y2="100%"
											stroke="#C4BAA3"
											strokeWidth="2"
											strokeDasharray="5 5"
										/>
									</svg>
								)}
								{!isLastRow && (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="100%"
										height="1"
										className="absolute"
										style={{
											top: 'auto',
											right: '0',
											bottom: '0',
											left: '0',
										}}
									>
										<line
											x1="0"
											y1="0"
											x2="100%"
											y2="0"
											stroke="#C4BAA3"
											strokeWidth="2"
											strokeDasharray="5 5"
										/>
									</svg>
								)}
								{country.img && (
									<img
										src={country.img}
										alt={country.name}
										className="xl:w-[104px] lg:w-[104px] md:w-[104px] sm:w-[62px] w-[62px]
										xl:h-[104px] lg:h-[104px] md:h-[104px] sm:h-[62px] h-[62px]
										rounded-full object-cover mb-2.5"
									/>
								)}
								<p
									className={`text-goudy font-normal uppercase text-center text-black leading-[120%]
									${country.name === '+25'
											? 'xl:text-[52px] lg:text-[52px] md:text-[40px] text-[40px]'
											: 'xl:text-[26px] lg:text-[24px] md:text-[15px]'
										}`}
								>
									{country.name}
								</p>
								<p className="text-[16px] leading-[120%] font-google font-normal text-center text-black">
									{country.subText}
								</p>
							</div>
						);
					})}
				</div>

				<div
					className="relative w-full h-0 2xl:my-[48px] xl:my-[48px] lg:my-[48px] md:my-[48px] sm:my-[30px] my-[30px] opacity-100"
					style={{
						boxShadow: '0px 4px 20px 0px #00000014',
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="100%"
						height="1"
						className="absolute top-0 left-0"
					>
						<line
							x1="0"
							y1="0"
							x2="100%"
							y2="0"
							stroke="#C4BAA3"
							strokeWidth="2"
							strokeDasharray="5,5"
						/>
					</svg>
				</div>

				<div className="grid grid-cols-2 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 xl:w-[1200px] lg:w-[900px] md:w-[600px] sm:w-[353px] ms:w-[353px] xs:w-auto bg-white xl:h-[475px] lg:h-[610px] md:h-fit items-center xl:gap-[12px] lg:gap-[12px] md:gap-[12px] sm:gap-[16px] gap-[16px] justify-center justify-items-center">
					{logos.map((logo, index) => {
						const content = (
							<div
								key={index}
								className={`bg-white xl:w-[291px] lg:w-[291px] md:w-[291px] sm:w-[169px] ms:w-[169px] xs:w-[140px] xl:h-[150px] lg:h-[150px] md:h-[150px] sm:h-[122px] h-[122px] flex items-center justify-center xl:rounded-[24px] lg:rounded-[24px] md:rounded-[24px] sm:rounded-[16px] rounded-[16px] relative ${logo.id === 44 ? 'hidden sm:flex' : ''
									}`}
								style={{
									boxShadow: '0px 4px 20px 0px #0000000F',
									visibility:
										logo.id == 44 ? 'hidden' : 'visible',
									display:
										logo.id == 44 && isTablet ? 'none' : '',
								}}
							>
								<DashedBorder
									radiusDesktop={24}
									radiusMobile={16}
								/>
								{logo.img ? (
									<img
										src={logo.img}
										alt={logo.name}
										style={{
											width: isSmallScreen
												? logo.smImgWidth
												: logo.imgWidth,
											height: isSmallScreen
												? logo.smImgHeight
												: logo.imgHeight,
											objectFit: 'contain',
										}}
									/>
								) : (
									<p className="text-center">
										<span className="xl:text-[52px] lg:text-[52px] md:text-[38px] text-[32px] leading-[120%] text-goudy font-normal uppercase text-center text-black">
											+150
										</span>
										<br />
										<p className="text-[14px] xl:text-[16px] lg:text-[16px] md:text-[14px] leading-[120%] font-plusJakarta font-normal text-center text-black">
											Brands Worldwide
										</p>
									</p>
								)}
							</div>
						);

						return logo.url ? (
							<a
								key={index}
								href={logo.url}
								target="_blank"
								rel="noopener noreferrer"
							>
								{content}
							</a>
						) : (
							content
						);
					})}
				</div>
				<div className="flex xl:w-[1200px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full bg-white grid grid-cols-2 xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 h-[79px] xl:mt-[62px] lg:mt-[62px] md:mt-10 sm:mt-[32px] mt-[32px] justify-between gap-y-6 h-[154px] sm:h-[154px] md:h-[80px] lg:h-[80px] xl:h-[80px]">
					{stats.map((stat, index) => (
						<span
							key={index}
							className="flex flex-col items-center gap-[12px]"
						>
							<CrownIcon
								width={iconSize}
								height={iconSize}
							/>
							<p className="xl:text-[16px] lg:text-[16px] md:text-[12px] text-[14px] leading-[120%] font-plusJakarta font-normal text-center whitespace-nowrap text-[#000000]">
								{stat.value}{' '}
								{isSmallScreen && stat.shortLabel
									? stat.shortLabel
									: stat.label}
							</p>
							<div className="xl:w-[285px] lg:w-[200px] md:w-[150px] w-[150px] h-[4px] bg-[#C4BAA3] rounded-[30px] opacity-100"></div>
						</span>
					))}
				</div>
			</div>
			<div className="w-full xl:h-[993px] lg:h-[960px] md:h-[915px] sm:h-[714px] ms:h-[714px] xs:h-[730px] flex bg-[#EBEBE6]/40  xl:pt-[120px] lg:pt-[120px] md:pt-[80px] sm:pt-[60px] pt-[60px] flex-col items-center">
				<h1 className=" text-black text-goudy xl:font-normal lg:font-normal md:font-normal sm:font-bold font-bold xl:text-[52px] lg:text-[52px] md:text-[40px] text-[28px] leading-[120%] text-center">
					Our Diverse Range Of Products
				</h1>

				<span className="xl:w-[692px] lg:w-full w-full xl:h-[55px] lg:h-[55px] md:h-[55px] sm:h-fit h-fit flex justify-center relative xl:mt-[56px] lg:mt-[56px] md:mt-[56px] sm:mt-[20px] mt-[20px]">
					<div className="relative w-full sm:w-full xl:w-[692px] lg:w-[692px] md:w-[692px] xl:h-[55px] lg:h-[55px] md:h-[55px] sm:h-[108px] h-[108px] xl:rounded-[28px] lg:rounded-[28px] md:rounded-[28px] sm:rounded-0 rounded-0 shadow-[0px_4px_20px_0px_#0000000F] bg-white opacity-100 xl:p-0.5 lg:p-0.5 md:p-0.5 sm:px-[15px] px-[15px] xl:flex lg:flex md:flex sm:grid grid justify-between grid-cols-2 items-center">
						{!isSmallScreen && (
							<DashedBorder
								radiusDesktop={28}
								radiusMobile={28}
							/>
						)}
						<button
							onClick={() =>
								setSelectedCategory('Retail & Shopping')
							}
							className={`xl:px-[24px] lg:px-[24px] md:px-[24px] sm:px-[16px] ms:px-[13px] xs:px-[13px] py-[10px] rounded-[30px] xl:text-[16px] lg:text-[16px] md:text-[14px] sm:text-[14px] ms:text-[13px] xs:text-[12px] leading-[100%] font-[500] font-google xl:h-full lg:h-full md:h-full sm:h-[40px] h-fit w-fit ${selectedCategory === 'Retail & Shopping'
									? 'bg-black text-white'
									: 'bg-white text-black'
								}`}
						>
							Retail & Shopping Bags
						</button>
						<button
							onClick={() => setSelectedCategory('Agriculture')}
							className={`xl:px-[24px] lg:px-[24px] md:px-[24px] sm:px-[16px] ms:px-[13px] xs:px-[13px] py-[10px] rounded-[30px] xl:text-[16px] lg:text-[16px] md:text-[14px] sm:text-[14px] ms:text-[13px] xs:text-[12px] leading-[100%] font-[500] font-google xl:h-full lg:h-full md:h-full sm:h-[40px] h-fit w-fit ${selectedCategory === 'Agriculture'
									? 'bg-black text-white'
									: 'bg-white text-black'
								}`}
						>
							Agriculture Applications
						</button>
						<div className="sm:col-span-2 sm:flex sm:justify-center ms:flex ms:col-span-2 ms:justify-center xs:flex xs:col-span-2 xs:justify-center h-full">
							<button
								onClick={() =>
									setSelectedCategory('Pharmaceutical')
								}
								className={`xl:px-[24px] lg:px-[24px] md:px-[24px] sm:px-[16px] ms:px-[13px] xs:px-[13px] py-[10px] rounded-[30px] xl:text-[16px] lg:text-[16px] md:text-[14px] sm:text-[14px] ms:text-[13px] xs:text-[12px] leading-[100%] font-[500] font-google xl:h-full lg:h-full md:h-full sm:h-[40px] h-fit w-fit ${selectedCategory === 'Pharmaceutical'
										? 'bg-black text-white'
										: 'bg-white text-black'
									}`}
							>
								Pharmaceutical & Hygiene
							</button>
						</div>
					</div>
				</span>
				{/* <div className="xl:w-[1201px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full xl:h-[438px] lg:h-fit md:h-fit xl:mt-[54px] lg:mt-[54px] md:mt-[54px] sm:mt-[32px] mt-[32px] flex justify-center">
					<div className="flex justify-between hidden md:grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 xl:gap-[20px] lg:gap-[20px] md:gap-[20px]">
						{filteredProducts.map((p, idx) => (
							<div
								key={idx}
								className="relative w-[387px] h-[438px] bg-white rounded-[24px] shadow-[0px_4px_20px_0px_#0000000F] opacity-100"
							>
								<DashedBorder
									radiusDesktop={24}
									radiusMobile={24}
								/>
								<div>
									<div className="w-[355px] h-[241px] bg-white rounded-[12px] mx-[16px] mt-[16px]">
										<img
											src={images[p.image]}
											alt="product"
										/>
									</div>
									<h3 className="pt-[20px] px-[24px]  xl:text-[20px] lg:text-[20px] md:text-[16px] sm:text-[14px] text-[14px] leading-[100%] font-bold font-plusJakarta">
										{p.name}
									</h3>

									<p className="pt-[12px] px-[24px] xl:text-[16px] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[14px] leading-[150%] font-[400px] font-normal font-plusJakarta text-[#1D1D1D]">
										{p.description}
									</p>
									<span
										className="font-plusJakarta pt-[24px] xl:px-[24px] lg:px-[24px] md:px-[24px] sm:px-[10px] px-[10px] font-[500] xl:text-[16px] lg:text-[16px] md:text-[16px] sm:text-[15px] text-[15px] leading-[100%] tracking-[0] text-black underline decoration-solid decoration-[1px] underline-offset-[4px] cursor-pointer flex items-center gap-2"
										onClick={() => navigate('/contact')}
									>
										Get Quote
										<span>
											<RightArrowIcon
												color="black"
												width={iconSize}
												height={iconSize}
											/>
										</span>
									</span>
									
								</div>
							</div>
						))}
					</div>
					<div
						className="md:hidden w-full mx-4 overflow-x-auto scroll-smooth snap-x snap-mandatory"
						style={{
							scrollbarWidth: 'none',
							msOverflowStyle: 'none',
						}}
					>
						<div className="flex gap-4">
							{filteredProducts.map((p, idx) => (
								<div
									key={idx}
									className="bg-white rounded-[16px] shadow-[0_4px_20px_0_#0000000F] flex-shrink-0 w-[261px] h-[323px] snap-start relative flex flex-col"
								>
									<DashedBorder
										radiusDesktop={24}
										radiusMobile={16}
									/>
									<div className="w-[245px] h-[166px] bg-gray-200 rounded-[12px] mt-[8px] mx-[8px]">
										<img
											src={images[p.image]}
											alt="product"
										/>
									</div>
									<h3 className="pt-[14px] text-[16px] leading-[100%] font-[700] font-plusJakarta px-[18px] text-[#1D1D1D]">
										{p.name}
									</h3>
									<p className="pt-[8px] text-[14px] leading-[150%] font-[400] font-plusJakarta text-[#1D1D1D] px-[18px]">
										{p.description}
									</p>
									<span
										className="font-plusJakarta pt-[16px] px-[18px] font-[500] text-[14px] leading-[100%] tracking-[0] text-black underline decoration-solid decoration-[1px] underline-offset-[4px] cursor-pointer flex items-center gap-2"
										onClick={() => navigate('/contact')}
									>
										Get Quote
										<span>
											<RightArrowIcon
												color="black"
												width={iconSize}
												height={iconSize}
											/>
										</span>
									</span>
								
								</div>
							))}
						</div>
					</div>
				</div> */}

				<div
					className={`w-full xl:h-[438px] lg:h-fit md:h-fit xl:mt-[54px] lg:mt-[54px] md:mt-[54px] sm:mt-[32px] mt-[32px] flex justify-start`}
					ref={scrollWrapperRef}
				>
					<div
						className="w-full overflow-x-auto scroll-smooth snap-x snap-mandatory transition-all duration-300 ease-in-out
								xl:pl-[100px] xl:pr-[100px] xl:mx-0 lg:mx-8 md:mx-6 sm:mx-4 ms:mx-4 xs:mx-4"
						style={{
							scrollbarWidth: 'none',
							msOverflowStyle: 'none',
							scrollPaddingInline: '200px',
						}}
						ref={scrollContainerRef}
					>
						<div className="flex md:gap-[20px] gap-[16px]">
							{filteredProducts.map((p, idx) => (
								<div
									key={idx}
									className="relative xl:w-[387px] lg:w-[387px] md:w-[387px] sm:w-[261px] w-[261px] xl:h-[438px] lg:h-[438px] md:h-[438px] sm:h-[323px] h-[323px] bg-white xl:rounded-[24px] lg:rounded-[24px] md:rounded-[24px] sm:rounded-[16px] rounded-[16px] shadow-[0px_4px_20px_0px_#0000000F] opacity-100 flex-shrink-0 snap-start sm:px-[8px] px-[8px] md:px-[16px] lg:px-[16px] xl:px-[16px] pt-[8px] sm:pt-[8px] md:pt-[16px] lg:pt-[16px] xl:pt-[16px]"
								>
									<DashedBorder
										radiusDesktop={24}
										radiusMobile={16}
									/>
									<div className="xl:w-[355px] lg:w-[355px] md:w-[355px] sm:w-[245px] w-[245px] xl:h-[241px] lg:h-[241px] md:h-[241px] sm:h-[166px] h-[166px] bg-white rounded-[12px] ">
										<img
											src={images[p.image]}
											alt="product"
											className="pointer-events-auto select-none"
										/>
									</div>
									<h3 className="pt-[14px] sm:pt-[14px] md:pt-[20px] lg:pt-[20px] xl:pt-[20px] xl:text-[20px] lg:text-[20px] md:text-[16px] sm:text-[16px] text-[16px] leading-[100%] font-[700] font-plusJakarta text-black xl:px-[8px] lg:px-[8px] md:px-[8px] sm:px-[10px] px-[10px]">
										{p.name}
									</h3>

									<p className="h-fit pt-[10px] sm:pt-[10px] md:pt-[12px] lg:pt-[12px] xl:pt-[12px] xl:text-[16px] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[14px] leading-[150%] font-[400] font-plusJakarta text-[#1D1D1D] xl:px-[8px] lg:px-[8px] md:px-[8px] sm:px-[10px] px-[10px] line-clamp-2 overflow-hidden">
										{p.description}
									</p>
									<span
										className="w-fit font-plusJakarta mt-[16px] xl:px-[8px] lg:px-[8px] md:px-[8px] sm:px-[10px] px-[10px] font-[500] xl:text-[16px] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[14px]  leading-[100%] tracking-[0] text-black underline decoration-solid decoration-[1px] underline-offset-[4px] cursor-pointer flex items-center gap-2"
										onClick={() => navigate('/contact')}
									>
										Get Quote
										<RightArrowIcon
											color="black"
											width={iconSize}
											height={iconSize}
										/>
									</span>
								</div>
							))}
							<div className="hidden xl:block flex-shrink-0 w-[100px]" />
						</div>
					</div>
				</div>

				<button
					className=" flex items-center justify-center xl:gap-[10px] lg:gap-[10px] md:gap-[10px] sm:gap-[4px] gap-[4px] rounded-[30px] opacity-100 bg-black xl:h-[47px] lg:h-[47px] md:h-[47px] sm:h-[40px] h-[40px] xl:w-[231px] lg:w-[231px] md:w-[231px] sm:w-[195px] w-[195px] cursor-pointer mt-10 text-white xl:text-[16px] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[14px] font-google font-medium leading-[100%] tracking-[0%] py-[10px] xl:px-[24px] lg:px-[24px] md:px-[24px] sm:px-[20px] px-[20px]"
					style={{
						boxShadow: '0px 4px 20px 0px #0000001F',
					}}
					onClick={() => navigate('/products')}
				>
					Explore All Products
					<RightArrowIcon
						width={iconSize}
						height={iconSize}
					/>
				</button>
			</div>
			<Downloadbroch />
			<Footer />
		</div>
	);
};

export default Home;
